import React, { useEffect } from 'react'

const HtmlRawContainer = ({ containerObject, templateName, contentId, dataZone }) => {

  useEffect(() => {
    handleVideo()
    handleHsForm()
    var hash = window.location.hash;
  if (hash) {
    var element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
  }, [])
  function handleHsForm() {
    const hsClass = document.querySelector(".ngssebook-copy");

    if (hsClass) {
      var portalId = hsClass.getAttribute("portalId");
      var formId = hsClass.getAttribute("formId");
      var region = hsClass.getAttribute("region");
      var height = hsClass.getAttribute("height");
      var hubUrl = hsClass.getAttribute("hubSpotUrl");
      var hubSpotUrl = `/${hubUrl ? hubUrl : "hubSpot"}?portalId=${portalId ? portalId : "44059706"}&formId=${formId ? formId : "369d68d2-7993-4ddc-91ad-46914ae7f1d7"}&region=${region ? region : "nal"}`


      hsClass.innerHTML = ` <iframe className="pdpHubspotForm" scrolling="no" style="width: 100%;height: ${height ? height : "1018px"}"  src=${hubSpotUrl} />`;

    }
  }
  function handleVideo() {
    const head = document.querySelector("#videoUrl");
    const scriptTagId = document.querySelectorAll("#multiVideo");
    let url;

    if (scriptTagId) {
      for (let i = 0; i < scriptTagId.length; i++) {
        const script = document.createElement("script");
        url = scriptTagId[i].getAttribute("src");
        if (url) {
          script.setAttribute("src", url);
          script.setAttribute("id", "customId");
          head.appendChild(script);
        }
      }
    }
    return () => {
      const scriptTag = document.querySelectorAll("#customId");
      if (scriptTag) {
        for (let i = 0; i < scriptTag.length; i++) {
          head.removeChild(scriptTag[i]);
        }
      };
    }
  }

  return (

    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0 cb-html-content`} >
      {containerObject && containerObject.attributes && containerObject.attributes.htmlRawContent ? <span dangerouslySetInnerHTML={{ __html: containerObject.attributes.htmlRawContent }}></span> : ""}
    </div>

  )
}

export default HtmlRawContainer